import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../locales/LanguageContext';

export const WizardProgress = ({ currentStep }) => {
  const { t } = useLanguage();
  const steps = t('wizard.steps');

  return (
    <div className="w-full mb-4 sm:mb-6 md:mb-8" data-testid="wizard-progress">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center flex-1">
              <div className={`
                w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center text-xs sm:text-sm md:text-base font-semibold
                transition-all duration-300
                ${index < currentStep 
                  ? 'bg-navy-800 text-white' 
                  : index === currentStep 
                    ? 'bg-navy-800 text-white ring-2 sm:ring-4 ring-indigo-100' 
                    : 'bg-slate-200 text-slate-400'}
              `} data-testid={`step-${index}`}>
                {index < currentStep ? <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5" /> : index + 1}
              </div>
              <p className={`
                mt-1 sm:mt-2 text-[9px] sm:text-xs font-medium text-center hidden sm:block
                ${index <= currentStep ? 'text-navy-900' : 'text-slate-400'}
              `}>
                {step}
              </p>
            </div>
            {index < steps.length - 1 && (
              <div className={`
                flex-1 h-0.5 sm:h-1 mx-1 sm:mx-2 rounded-full transition-all duration-300
                ${index < currentStep ? 'bg-navy-800' : 'bg-slate-200'}
              `} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
